import React, { useEffect, useState } from "react";
import { COMMAND_TYPES, confirmTargetOf } from "./imdRemoteApi";

// dialog ยืนยันคำสั่ง: ทุกคำสั่งต้องมีเหตุผล · คำสั่งทำลายต้องพิมพ์ชื่อเครื่องให้ตรงก่อน
// onSubmit ได้ { reason, confirm?, params? } — ประกอบ body ตาม contract ที่ parent
export default function ImdCommandDialog({ open, type, device, deleteCount = 0, submitting, error, onClose, onSubmit }) {
    const [reason, setReason] = useState("");
    const [confirmText, setConfirmText] = useState("");
    const [driverMode, setDriverMode] = useState("driverEmployeeId");
    const [driverValue, setDriverValue] = useState("");

    // เปิดใหม่ทุกครั้งต้องว่าง — ไม่ให้เหตุผล/ชื่อยืนยันของคำสั่งก่อนหน้าค้างไปคำสั่งถัดไป
    useEffect(() => {
        if (!open) return;
        setReason("");
        setConfirmText("");
        setDriverValue("");
    }, [open, type]);

    if (!open || !type) return null;

    const meta = COMMAND_TYPES[type];
    const target = confirmTargetOf(device);
    const needsDriver = type === "OPEN_SHIFT";
    const reasonOk = reason.trim().length > 0;
    const confirmOk = !meta.destructive || confirmText.trim() === target;
    const driverOk = !needsDriver || driverValue.trim().length > 0;
    const canSubmit = reasonOk && confirmOk && driverOk && !submitting;

    const submit = () => {
        if (!canSubmit) return;
        const body = { reason: reason.trim() };
        if (meta.destructive) body.confirm = target;
        if (needsDriver) body.params = { [driverMode]: driverValue.trim() };
        onSubmit(body);
    };

    return (
        <div role="presentation" style={overlay} onKeyDown={(e) => { if (e.key === "Escape") onClose(); }}>
            <div role="dialog" aria-modal="true" aria-labelledby="imd-cmd-dialog-title" style={box}>
                <h3 id="imd-cmd-dialog-title" style={{ marginTop: 0 }}>
                    {meta.label} — {device?.label || "เครื่องไม่มีชื่อ"}
                </h3>
                <p style={{ color: "#333", fontSize: "14px" }}>{meta.description}</p>
                {type === "DELETE_OUTBOX_ITEMS" && (
                    <p style={{ fontSize: "14px", fontWeight: "bold" }}>จะลบ {deleteCount} รายการ</p>
                )}
                {meta.warning && (
                    <div style={warnBox}>⚠️ {meta.warning}</div>
                )}

                {needsDriver && (
                    <div style={{ marginBottom: "10px" }}>
                        <label style={{ fontSize: "13px", marginRight: "12px" }}>
                            <input
                                type="radio"
                                name="driverMode"
                                checked={driverMode === "driverEmployeeId"}
                                onChange={() => setDriverMode("driverEmployeeId")}
                            /> รหัสพนักงาน
                        </label>
                        <label style={{ fontSize: "13px" }}>
                            <input
                                type="radio"
                                name="driverMode"
                                checked={driverMode === "driverNickname"}
                                onChange={() => setDriverMode("driverNickname")}
                            /> ชื่อเล่นคนขับ
                        </label>
                        <input
                            type="text"
                            aria-label="คนขับ"
                            value={driverValue}
                            onChange={(e) => setDriverValue(e.target.value)}
                            style={{ display: "block", width: "100%", padding: "8px", marginTop: "6px", boxSizing: "border-box" }}
                        />
                    </div>
                )}

                <label style={{ display: "block", fontSize: "13px", marginBottom: "4px" }}>เหตุผล (จำเป็น)</label>
                <textarea
                    aria-label="เหตุผล"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    rows={2}
                    style={{ width: "100%", padding: "8px", boxSizing: "border-box" }}
                />

                {meta.destructive && (
                    <div style={{ marginTop: "12px" }}>
                        <label style={{ display: "block", fontSize: "13px", marginBottom: "4px" }}>
                            พิมพ์ <b>{target}</b> เพื่อยืนยัน
                        </label>
                        <input
                            type="text"
                            aria-label="ยืนยันชื่อเครื่อง"
                            value={confirmText}
                            onChange={(e) => setConfirmText(e.target.value)}
                            style={{ width: "100%", padding: "8px", boxSizing: "border-box" }}
                        />
                    </div>
                )}

                {error && <div style={{ color: "#c00", marginTop: "10px", fontSize: "13px" }}>⚠️ {error}</div>}

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px" }}>
                    <button onClick={onClose} disabled={submitting} style={btnGhost}>ยกเลิก</button>
                    <button onClick={submit} disabled={!canSubmit} style={meta.destructive ? btnDanger : btnPrimary}>
                        {submitting ? "กำลังส่ง..." : "ยืนยันส่งคำสั่ง"}
                    </button>
                </div>
            </div>
        </div>
    );
}

const overlay = {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
    display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
};
const box = {
    background: "white", borderRadius: "6px", padding: "20px", width: "min(480px, 92vw)",
    boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
};
const warnBox = {
    background: "#fff3cd", border: "1px solid #ffe08a", padding: "8px", borderRadius: "4px", fontSize: "13px", marginBottom: "8px",
};
const btnBase = { padding: "8px 16px", border: "none", borderRadius: "4px", cursor: "pointer", color: "white" };
const btnPrimary = { ...btnBase, background: "#007bff" };
const btnDanger = { ...btnBase, background: "#c62828" };
const btnGhost = { ...btnBase, background: "#6c757d" };
